export enum DepartmentStatus {
  Closed = 'Closed',
  Active = 'Active',
}
export interface DepartmentData {
  id: string;
  name: string;
  status: DepartmentStatus;
}
